import { usePoints } from '@/src/common/hooks/usePoints'
import * as Stores from '../stores'

export function usePlatformPointsRedemption({
  creditAmount,
  dollarsPerPointConversion,
  cardAccountId,
}: {
  creditAmount: number
  dollarsPerPointConversion: number
  cardAccountId: (typeof Stores.PointsForStatementCreditApi.endpoints)['GET /card/accounts/:cardAccountId']['Types']['QueryArg']['params']['cardAccountId']
}) {
  const legacyPointsQuery = usePoints()
  const pointsBalance =
    legacyPointsQuery.initialized && legacyPointsQuery.query.data
      ? legacyPointsQuery.query.data.getPointsBalance.active.value
      : 'loading'

  const pointsToRedeem = Math.floor(creditAmount / dollarsPerPointConversion)

  const getCardAccountsById = Stores.PointsForStatementCreditApi.endpoints[
    'GET /card/accounts/:cardAccountId'
  ].useQuery({
    params: { cardAccountId },
  })

  const currentDollarBalance =
    getCardAccountsById.isUninitialized ||
    getCardAccountsById.isLoading ||
    !getCardAccountsById.data
      ? 'loading'
      : getCardAccountsById.data.summary.currentBalance.totalCents * 100

  const maxDollarValue =
    getCardAccountsById.isUninitialized ||
    getCardAccountsById.isLoading ||
    !getCardAccountsById.data
      ? 'loading'
      : getCardAccountsById.data.summary.remainingStatementBalanceCents * 100

  return {
    pointsBalance,
    pointsToRedeem,
    remainingPoints: pointsBalance === 'loading' ? 'loading' : pointsBalance - pointsToRedeem,
    conversionRate: `1 Mesa Point : $${dollarsPerPointConversion}` as const,
    queryLoading:
      getCardAccountsById.isUninitialized ||
      getCardAccountsById.isLoading ||
      !getCardAccountsById.data,
    currentDollarBalance,
    maxDollarValue,
  } as const
}
